// @flow

import React, { type Node } from 'react';

type TipModel = {
  imgSrc: string,
  tipText: string,
  altText: string,
}

type TipsBoxProps = {
  title: string,
  tipsModel: ImmutableArray<TipModel>,
}

export function TipsBox({ title, tipsModel }: TipsBoxProps): Node {
  return (
    <div style={TipsCardStyle}>
      <h1 style={TipsTitleStyle}>{title}</h1>
      {tipsModel.map(
        ({imgSrc, tipText, altText}, index) =>
          <div key={index} style={TipStyle}>
            <img src={imgSrc} alt={altText} style={TipIconStyle}/>
            <div style={TipTextStyle}>
              {tipText}
            </div>
          </div>
      )}
    </div>
  );
}

const TipsCardStyle = {
  background: '#f8f8f9',
  borderRadius: '5px',
  padding: '15px',
};

const TipsTitleStyle = {
  marginBottom: '15px',
  color: '#738093',
  fontWeight: '500',
  fontSize: '18px',
  textAlign: 'center',
};

const TipStyle = {
  display: 'flex',
  margin: '15px 0',
};

const TipIconStyle = {
  flex: '0 0 auto',
  height: '100%',
};

const TipTextStyle = {
  color: '#4e5765',
  fontSize: '14px',
  marginLeft: '15px',
};
